import React from 'react';
import { Link } from 'react-router-dom';
import aboutusicon from '../assets/navigation/aboutus.svg';
import blogicon from '../assets/navigation/blog.svg';
import casestudiesicon from '../assets/navigation/casestudies.svg';
import contacticon from '../assets/navigation/contact.svg';
import faqicon from '../assets/navigation/faq.svg';
import insightblockicon from '../assets/navigation/insightblock.svg';
import karriereicon from '../assets/navigation/karriere.svg';
import officeblockicon from '../assets/navigation/officeblock.svg';
import ressourcenicon from '../assets/navigation/ressourcen.svg';
import salesblockicon from '../assets/navigation/salesblock.svg';
import serviceblockicon from '../assets/navigation/serviceblock.svg';
import blckslogo from '../assets/icons/BLCKS_LOGO_NEW.svg';
import arrowdownicon from '../assets/icons/button-arrow-down-white.svg';
import arrowrighticon from '../assets/icons/button-arrow-right-lightgrey.svg';

const NavigationDesktop = () => {
  return (
    <nav className="absolute top-0 left-0 w-full py-4 z-50">
      <div className="w-[1344px] h-12 mx-auto flex items-center">
        {/* Logo - Links to Home */}
        <Link to="/" className="flex-shrink-0">
          <img src={blckslogo} alt="BLCKS" width={70} height={20} />
        </Link>
        
        {/* Navigation Links */}
        <div className="md:flex items-center ml-[100px] space-x-6">
          <Link to="/" className="flex items-center text-white text-sm font-geist font-normal tracking-[-0.02em] hover:text-gray-300 transition-colors">
            Home
          </Link>
          
          {/* Lösungen Dropdown */}
          <div className="group relative text-14 leading-none [perspective:2000px]">
            <button className="relative z-20 flex items-center gap-1.5 tracking-tight text-white text-sm font-geist font-normal tracking-[-0.02em] hover:text-gray-300 transition-colors cursor-pointer">
              Lösungen
              <img src={arrowdownicon} alt="" className="ml-1 w-4 h-4" />
            </button>
            <div className="pointer-events-none absolute top-full z-[60] w-[360px] pt-6 opacity-0 duration-200 transition-[opacity,transform] [transform:rotateX(-12deg)_scale(0.9)] group-hover:pointer-events-auto group-hover:visible group-hover:opacity-100 group-hover:[transform:none] -ml-5">
              <div className="bg-[rgba(11,12,15,0.99)] backdrop-blur-md rounded-xl border border-[rgba(22,24,29,1)] p-6" style={{ borderWidth: '1px' }}>
                <div className="relative">
                  <div className="mb-4 text-[11px] leading-none tracking-[0.01em]" style={{ color: 'rgba(120, 124, 135, 1)' }}>UNSERE LÖSUNGEN</div>
                  <ul className="flex flex-col gap-5">
                    <li className="h-[34px]">
                      <a 
                        href="#solutions-dash"
                        onClick={(e) => {
                          e.preventDefault();
                          const element = document.getElementById('solutions-dash');
                          if (element) {
                            element.scrollIntoView({ behavior: 'smooth' });
                            // Close mobile menu if open
                            const mobileMenu = document.getElementById('mobile-menu');
                            if (mobileMenu && !mobileMenu.classList.contains('hidden')) {
                              mobileMenu.classList.add('hidden');
                            }
                          }
                        }}
                        className="group/item relative flex items-center gap-2.5 pr-[26px] hover:bg-[#16181c] rounded-lg p-2 -mx-2 cursor-pointer"
                      >
                        <div className="relative flex h-[34px] w-[34px] items-center justify-center rounded-lg" style={{ backgroundColor: 'rgb(22,24,29,1)', border: '1px solid rgb(46,48,56,1)' }}>
                          <img src={salesblockicon} alt="" className="h-[18px] w-[18px]" />
                        </div>
                        <div className="relative min-w-px">
                          <div className="flex items-center">
                            <div className="truncate leading-dense tracking-[0.01em] transition-colors duration-100 group-hover/item:text-blue-60" style={{ color: 'rgba(239, 239, 241, 1)', fontSize: '14px' }}>
                              Sales Block
                            </div>
                          </div>
                          <div className="truncate font-light leading-dense transition-colors duration-100 group-hover/item:text-gray-60 mt-1 tracking-[0.01em]" style={{ color: 'rgba(120, 124, 135, 1)', fontSize: '12px' }}>
                            Leads generieren & schnellere Abschlüsse
                          </div>
                        </div>
                        <img src={arrowrighticon} alt="" className="absolute right-2 opacity-0 group-hover/item:opacity-100 transition-opacity h-4 w-4" style={{ color: 'rgba(239, 239, 241, 1)' }} />
                      </a>
                    </li>
                    <li className="h-[34px]">
                      <a 
                        href="#solutions-dash"
                        onClick={(e) => {
                          e.preventDefault();
                          const element = document.getElementById('solutions-dash');
                          if (element) {
                            element.scrollIntoView({ behavior: 'smooth' });
                            // Close mobile menu if open
                            const mobileMenu = document.getElementById('mobile-menu');
                            if (mobileMenu && !mobileMenu.classList.contains('hidden')) {
                              mobileMenu.classList.add('hidden');
                            }
                          }
                        }}
                        className="group/item relative flex items-center gap-2.5 pr-[26px] hover:bg-[#16181c] rounded-lg p-2 -mx-2 cursor-pointer"
                      >
                        <div className="relative flex h-[34px] w-[34px] items-center justify-center rounded-lg" style={{ backgroundColor: 'rgb(22,24,29,1)', border: '1px solid rgb(46,48,56,1)' }}>
                          <img src={officeblockicon} alt="" className="h-[18px] w-[18px]" />
                        </div>
                        <div className="relative min-w-px">
                          <div className="flex items-center">
                            <div className="truncate leading-dense tracking-[0.01em] transition-colors duration-100 group-hover/item:text-blue-60" style={{ color: 'rgba(239, 239, 241, 1)', fontSize: '14px' }}>
                              Office Block
                            </div>
                          </div>
                          <div className="truncate font-light leading-dense transition-colors duration-100 group-hover/item:text-gray-60 mt-1 tracking-[0.01em]" style={{ color: 'rgba(120, 124, 135, 1)', fontSize: '12px' }}>
                            Backoffice automatisieren & Zeit sparen
                          </div>
                        </div>
                        <img src={arrowrighticon} alt="" className="absolute right-2 opacity-0 group-hover/item:opacity-100 transition-opacity h-4 w-4" style={{ color: 'rgba(239, 239, 241, 1)' }} />
                      </a>
                    </li>
                    <li className="h-[34px]">
                      <a 
                        href="#solutions-dash"
                        onClick={(e) => {
                          e.preventDefault();
                          const element = document.getElementById('solutions-dash');
                          if (element) {
                            element.scrollIntoView({ behavior: 'smooth' });
                            // Close mobile menu if open
                            const mobileMenu = document.getElementById('mobile-menu');
                            if (mobileMenu && !mobileMenu.classList.contains('hidden')) {
                              mobileMenu.classList.add('hidden');
                            }
                          }
                        }}
                        className="group/item relative flex items-center gap-2.5 pr-[26px] hover:bg-[#16181c] rounded-lg p-2 -mx-2 cursor-pointer"
                      >
                        <div className="relative flex h-[34px] w-[34px] items-center justify-center rounded-lg" style={{ backgroundColor: 'rgb(22,24,29,1)', border: '1px solid rgb(46,48,56,1)' }}>
                          <img src={insightblockicon} alt="" className="h-[18px] w-[18px]" />
                        </div>
                        <div className="relative min-w-px">
                          <div className="flex items-center">
                            <div className="truncate leading-dense tracking-[0.01em] transition-colors duration-100 group-hover/item:text-blue-60" style={{ color: 'rgba(239, 239, 241, 1)', fontSize: '14px' }}>
                              Insight Block
                            </div>
                          </div>
                          <div className="truncate font-light leading-dense transition-colors duration-100 group-hover/item:text-gray-60 mt-1 tracking-[0.01em]" style={{ color: 'rgba(120, 124, 135, 1)', fontSize: '12px' }}>
                            Daten verstehen & Chancen nutzen
                          </div>
                        </div>
                        <img src={arrowrighticon} alt="" className="absolute right-2 opacity-0 group-hover/item:opacity-100 transition-opacity h-4 w-4" style={{ color: 'rgba(239, 239, 241, 1)' }} />
                      </a>
                    </li>
                    <li className="h-[34px]">
                      <a 
                        href="#solutions-dash"
                        onClick={(e) => {
                          e.preventDefault();
                          const element = document.getElementById('solutions-dash');
                          if (element) {
                            element.scrollIntoView({ behavior: 'smooth' });
                            // Close mobile menu if open
                            const mobileMenu = document.getElementById('mobile-menu');
                            if (mobileMenu && !mobileMenu.classList.contains('hidden')) {
                              mobileMenu.classList.add('hidden');
                            }
                          }
                        }}
                        className="group/item relative flex items-center gap-2.5 pr-[26px] hover:bg-[#16181c] rounded-lg p-2 -mx-2 cursor-pointer"
                      >
                        <div className="relative flex h-[34px] w-[34px] items-center justify-center rounded-lg" style={{ backgroundColor: 'rgb(22,24,29,1)', border: '1px solid rgb(46,48,56,1)' }}>
                          <img src={serviceblockicon} alt="" className="h-[18px] w-[18px]" />
                        </div>
                        <div className="relative min-w-px">
                          <div className="flex items-center">
                            <div className="truncate leading-dense tracking-[0.01em] transition-colors duration-100 group-hover/item:text-blue-60" style={{ color: 'rgba(239, 239, 241, 1)', fontSize: '14px' }}>
                              Service Block
                            </div>
                          </div>
                          <div className="truncate font-light leading-dense transition-colors duration-100 group-hover/item:text-gray-60 mt-1 tracking-[0.01em]" style={{ color: 'rgba(120, 124, 135, 1)', fontSize: '12px' }}>
                            Kundenservice skalieren & verbessern
                          </div>
                        </div>
                        <img src={arrowrighticon} alt="" className="absolute right-2 opacity-0 group-hover/item:opacity-100 transition-opacity h-4 w-4" style={{ color: 'rgba(239, 239, 241, 1)' }} />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          
          <a 
            href="#consulting"
            onClick={(e) => {
              e.preventDefault();
              const element = document.querySelector('[data-section="consulting"]');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
                // Update URL without page reload
                window.history.pushState(null, '', '/#consulting');
                // Close mobile menu if open
                const mobileMenu = document.getElementById('mobile-menu');
                if (mobileMenu && !mobileMenu.classList.contains('hidden')) {
                  mobileMenu.classList.add('hidden');
                }
              }
            }}
            className="flex items-center text-white text-sm font-geist font-normal tracking-[-0.02em] hover:text-gray-300 transition-colors"
          >
            Consulting
          </a>
          <Link to="/pricing" className="flex items-center text-white text-sm font-geist font-normal tracking-[-0.02em] hover:text-gray-300 transition-colors">
            Preise
          </Link>
          {/* Ressourcen Dropdown */}
          <div className="group relative text-14 leading-none [perspective:2000px]">
            <button className="relative z-20 flex items-center gap-1.5 tracking-tight text-white text-sm font-geist font-normal tracking-[-0.02em] hover:text-gray-300 transition-colors cursor-pointer">
              Ressourcen
              <img src={arrowdownicon} alt="" className="ml-1 w-4 h-4" />
            </button>
            <div className="pointer-events-none absolute top-full z-[60] w-[280px] pt-6 opacity-0 duration-200 transition-[opacity,transform] [transform:rotateX(-12deg)_scale(0.9)] group-hover:pointer-events-auto group-hover:visible group-hover:opacity-100 group-hover:[transform:none] -ml-5">
              <div className="bg-[rgba(11,12,15,0.99)] backdrop-blur-md rounded-xl border border-[rgba(22,24,29,1)] p-6" style={{ borderWidth: '1px' }}>
                <div className="relative">
                  <div className="mb-4 text-[11px] leading-none tracking-tight" style={{ color: 'rgba(120, 124, 135, 1)' }}>RESSOURCEN</div>
                  <ul className="flex flex-col gap-4">
                    <li className="h-[34px]">
                      <Link to="/faq" className="group/item relative flex items-center gap-2.5 pr-[26px] hover:bg-[#16181c] rounded-lg p-2 -mx-2">
                        <div className="relative flex h-[34px] w-[34px] items-center justify-center rounded-lg" style={{ backgroundColor: 'rgb(22,24,29,1)', border: '1px solid rgb(46,48,56,1)' }}>
                          <img src={faqicon} alt="" className="h-[18px] w-[18px]" />
                        </div>
                        <div className="relative min-w-px">
                          <div className="flex items-center">
                            <div className="truncate leading-dense tracking-[0.01em] transition-colors duration-100 group-hover/item:text-blue-60" style={{ color: 'rgba(239, 239, 241, 1)', fontSize: '14px' }}>
                              FAQ
                            </div>
                          </div>
                          <div className="truncate font-light leading-dense transition-colors duration-100 group-hover/item:text-gray-60 mt-1 tracking-[0.01em]" style={{ color: 'rgba(120, 124, 135, 1)', fontSize: '12px' }}>
                            Häufig gestellte Fragen
                          </div>
                        </div>
                        <img src={arrowrighticon} alt="" className="absolute right-2 opacity-0 group-hover/item:opacity-100 transition-opacity h-4 w-4" style={{ color: 'rgba(239, 239, 241, 1)' }} />
                      </Link>
                    </li>
                    <li className="h-[34px]">
                      <Link to="/blog" className="group/item relative flex items-center gap-2.5 pr-[26px] hover:bg-[#16181c] rounded-lg p-2 -mx-2">
                        <div className="relative flex h-[34px] w-[34px] items-center justify-center rounded-lg" style={{ backgroundColor: 'rgb(22,24,29,1)', border: '1px solid rgb(46,48,56,1)' }}>
                          <img src={blogicon} alt="" className="h-[18px] w-[18px]" />
                        </div>
                        <div className="relative min-w-px">
                          <div className="flex items-center">
                            <div className="truncate leading-dense tracking-[0.01em] transition-colors duration-100 group-hover/item:text-blue-60" style={{ color: 'rgba(239, 239, 241, 1)', fontSize: '14px' }}>
                              Blog & Artikel
                            </div>
                          </div>
                          <div className="truncate font-light leading-dense transition-colors duration-100 group-hover/item:text-gray-60 mt-1 tracking-[0.01em]" style={{ color: 'rgba(120, 124, 135, 1)', fontSize: '12px' }}>
                            Coming soon! {/* Aktuelle Insights & Nachrichten */}
                          </div>
                        </div>
                        <img src={arrowrighticon} alt="" className="absolute right-2 opacity-0 group-hover/item:opacity-100 transition-opacity h-4 w-4" style={{ color: 'rgba(239, 239, 241, 1)' }} />
                      </Link>
                    </li>
                    <li className="h-[34px]">
                      <Link to="/" className="group/item relative flex items-center gap-2.5 pr-[26px] hover:bg-[#16181c] rounded-lg p-2 -mx-2">
                        <div className="relative flex h-[34px] w-[34px] items-center justify-center rounded-lg" style={{ backgroundColor: 'rgb(22,24,29,1)', border: '1px solid rgb(46,48,56,1)' }}>
                          <img src={casestudiesicon} alt="" className="h-[18px] w-[18px]" />
                        </div>
                        <div className="relative min-w-px">
                          <div className="flex items-center">
                            <div className="truncate leading-dense tracking-[0.01em] transition-colors duration-100 group-hover/item:text-blue-60" style={{ color: 'rgba(239, 239, 241, 1)', fontSize: '14px' }}>
                              Fallstudien
                            </div>
                          </div>
                          <div className="truncate font-light leading-dense transition-colors duration-100 group-hover/item:text-gray-60 mt-1 tracking-[0.01em]" style={{ color: 'rgba(120, 124, 135, 1)', fontSize: '12px' }}>
                            Coming soon!
                          </div>
                        </div>
                        <img src={arrowrighticon} alt="" className="absolute right-2 opacity-0 group-hover/item:opacity-100 transition-opacity h-4 w-4" style={{ color: 'rgba(239, 239, 241, 1)' }} />
                      </Link>
                    </li>
                    <li className="h-[34px]">
                      <Link to="/" className="group/item relative flex items-center gap-2.5 pr-[26px] hover:bg-[#16181c] rounded-lg p-2 -mx-2">
                        <div className="relative flex h-[34px] w-[34px] items-center justify-center rounded-lg" style={{ backgroundColor: 'rgb(22,24,29,1)', border: '1px solid rgb(46,48,56,1)' }}>
                          <img src={ressourcenicon} alt="" className="h-[18px] w-[18px]" />
                        </div>
                        <div className="relative min-w-px">
                          <div className="flex items-center">
                            <div className="truncate leading-dense tracking-[0.01em] transition-colors duration-100 group-hover/item:text-blue-60" style={{ color: 'rgba(239, 239, 241, 1)', fontSize: '14px' }}>
                              Ressourcen
                            </div>
                          </div>
                          <div className="truncate font-light leading-dense transition-colors duration-100 group-hover/item:text-gray-60 mt-1 tracking-[0.01em]" style={{ color: 'rgba(120, 124, 135, 1)', fontSize: '12px' }}>
                            Coming soon!
                          </div>
                        </div>
                        <img src={arrowrighticon} alt="" className="absolute right-2 opacity-0 group-hover/item:opacity-100 transition-opacity h-4 w-4" style={{ color: 'rgba(239, 239, 241, 1)' }} />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Blcks Dropdown */}
          <div className="group relative text-14 leading-none [perspective:2000px]">
            <button className="relative z-20 flex items-center gap-1.5 tracking-tight text-white text-sm font-geist font-normal tracking-[-0.02em] hover:text-gray-300 transition-colors cursor-pointer">
              blcks
              <img src={arrowdownicon} alt="" className="ml-1 w-4 h-4" />
            </button>
            <div className="pointer-events-none absolute top-full z-[60] w-[280px] pt-6 opacity-0 duration-200 transition-[opacity,transform] [transform:rotateX(-12deg)_scale(0.9)] group-hover:pointer-events-auto group-hover:visible group-hover:opacity-100 group-hover:[transform:none] -ml-5">
              <div className="bg-[rgba(11,12,15,0.99)] backdrop-blur-md rounded-xl border border-[rgba(22,24,29,1)] p-6" style={{ borderWidth: '1px' }}>
                <div className="relative">
                  <div className="mb-4 text-[11px] leading-none tracking-[0.01em]" style={{ color: 'rgba(120, 124, 135, 1)' }}>ÜBER BLCKS</div>
                  <ul className="flex flex-col gap-4">
                    <li className="h-[34px]">
                      <Link to="/about" className="group/item relative flex items-center gap-2.5 pr-[26px] hover:bg-[#16181c] rounded-lg p-2 -mx-2">
                        <div className="relative flex h-[34px] w-[34px] items-center justify-center rounded-lg" style={{ backgroundColor: 'rgb(22,24,29,1)', border: '1px solid rgb(46,48,56,1)' }}>
                          <img src={aboutusicon} alt="" className="h-[18px] w-[18px]" />
                        </div>
                        <div className="relative min-w-px">
                          <div className="flex items-center">
                            <div className="truncate leading-dense tracking-[0.01em] transition-colors duration-100 group-hover/item:text-blue-60" style={{ color: 'rgba(239, 239, 241, 1)', fontSize: '14px' }}>
                              Über uns
                            </div>
                          </div>
                          <div className="truncate font-light leading-dense transition-colors duration-100 group-hover/item:text-gray-60 mt-1 tracking-[0.01em]" style={{ color: 'rgba(120, 124, 135, 1)', fontSize: '12px' }}>
                            Unser Team & Vision
                          </div>
                        </div>
                        <img src={arrowrighticon} alt="" className="absolute right-2 opacity-0 group-hover/item:opacity-100 transition-opacity h-4 w-4" style={{ color: 'rgba(239, 239, 241, 1)' }} />
                      </Link>
                    </li>
                    <li className="h-[34px]">
                      <Link to="/" className="group/item relative flex items-center gap-2.5 pr-[26px] hover:bg-[#16181c] rounded-lg p-2 -mx-2">
                        <div className="relative flex h-[34px] w-[34px] items-center justify-center rounded-lg" style={{ backgroundColor: 'rgb(22,24,29,1)', border: '1px solid rgb(46,48,56,1)' }}>
                          <img src={karriereicon} alt="" className="h-[18px] w-[18px]" />
                        </div>
                        <div className="relative min-w-px">
                          <div className="flex items-center">
                            <div className="truncate leading-dense tracking-[0.01em] transition-colors duration-100 group-hover/item:text-blue-60" style={{ color: 'rgba(239, 239, 241, 1)', fontSize: '14px' }}>
                              Karriere
                            </div>
                          </div>
                          <div className="truncate font-light leading-dense transition-colors duration-100 group-hover/item:text-gray-60 mt-1 tracking-[0.01em]" style={{ color: 'rgba(120, 124, 135, 1)', fontSize: '12px' }}>
                            Coming soon!
                          </div>
                        </div>
                        <img src={arrowrighticon} alt="" className="absolute right-2 opacity-0 group-hover/item:opacity-100 transition-opacity h-4 w-4" style={{ color: 'rgba(239, 239, 241, 1)' }} />
                      </Link>
                    </li>
                    <li className="h-[34px]">
                      <Link to="/contact" className="group/item relative flex items-center gap-2.5 pr-[26px] hover:bg-[#16181c] rounded-lg p-2 -mx-2">
                        <div className="relative flex h-[34px] w-[34px] items-center justify-center rounded-lg" style={{ backgroundColor: 'rgb(22,24,29,1)', border: '1px solid rgb(46,48,56,1)' }}>
                          <img src={contacticon} alt="" className="h-[18px] w-[18px]" />
                        </div>
                        <div className="relative min-w-px">
                          <div className="flex items-center">
                            <div className="truncate leading-dense tracking-[0.01em] transition-colors duration-100 group-hover/item:text-blue-60" style={{ color: 'rgba(239, 239, 241, 1)', fontSize: '14px' }}>
                              Kontakt
                            </div>
                          </div>
                          <div className="truncate font-light leading-dense transition-colors duration-100 group-hover/item:text-gray-60 mt-1 tracking-[0.01em]" style={{ color: 'rgba(120, 124, 135, 1)', fontSize: '12px' }}>
                            Schreibe uns eine Nachricht!
                          </div>
                        </div>
                        <img src={arrowrighticon} alt="" className="absolute right-2 opacity-0 group-hover/item:opacity-100 transition-opacity h-4 w-4" style={{ color: 'rgba(239, 239, 241, 1)' }} />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Right Side Buttons */}
        <div className="ml-auto flex items-center space-x-4">
          <Link to="/contact" className="text-white text-sm font-geist font-normal tracking-[-0.02em] hover:text-gray-300 transition-colors">
            Kontakt
          </Link>
          <a 
            href="https://audit.blcks.at"
            target="_blank"
            rel="noopener noreferrer"
            className="w-[124px] h-7 flex items-center justify-center border border-[#2e3038] rounded-full text-white text-sm font-geist font-normal tracking-[-0.02em] hover:border-gray-400 transition-colors hover:bg-white/5"
          >
            Analyse starten
          </a>
        </div>
      </div>
    </nav>
  );
};

export default NavigationDesktop;